<template>
  <div
    :style="{ backgroundColor, color: backgroundColor ? calColorByBackground(backgroundColor) : undefined }"
    class="text-white text-[10px] xl:text-xs px-1.5 2xl:px-2 py-1 rounded transition flex items-center flex-nowrap max-w-[65%] space-x-0.5 2xl:space-x-1 bg-gs-green/90"
  >
    <span class="flex-1 truncate" :class="[teamName && 'font-bold']">{{ name }}</span>
    <span v-if="teamName" class="truncate">| {{ teamName }}</span>
    <MicrophoneIcon v-if="isMuted" icon-class="h-3 w-3 2xl:h-4 2xl:w-4" class="flex-shrink-0" />
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import { calColorByBackground } from "@/utils/utils";

defineProps<{
  backgroundColor?: string;
  teamName?: string;
  name?: string;
  isMuted?: boolean;
}>();
</script>
